import { fileAdapter } from '@/adapters/constructor/utils/file';

export default ({ data }) => {
  return {
    files: data.files?.map(fileAdapter),
  };
};
